import { getUserPaymentOptions } from "@/features/users/users.queries";
import { InvoiceCheckout } from "@/pages/InvoiceCheckout";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/invoice-checkout")({
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    pickupId?: string;
    documentNumber?: string[];
    redirectUrl?: string;
  } => {
    const pickupId = search.pickupId ? String(search.pickupId) : undefined;
    const documentNumber = search.documentNumber
      ? Array.isArray(search.documentNumber)
        ? search.documentNumber.map(String)
        : [String(search.documentNumber)]
      : undefined;

    if (pickupId && documentNumber) {
      throw new Error(
        "Please provide either pickupId or documentNumber, not both.",
      );
    }

    return {
      pickupId,
      documentNumber,
      redirectUrl: search.redirectUrl ? String(search.redirectUrl) : undefined,
    };
  },
  loaderDeps: (search) => search,
  loader: async ({ context, location }) => {
    const { queryClient } = context;
    if (Object.keys(location.search).length === 0) {
      throw redirect({
        to: "/payment",
      });
    }
    try {
      await queryClient.ensureQueryData(
        getUserPaymentOptions({ staleTime: 5000 }),
      );
    } catch (error) {
      throw redirect({
        to: "/payment",
      });
    }
  },
  component: InvoiceCheckout,
});
